// Plan ▸ Outliner: the contents as a table of fields, with Group and Sort beside the tabs.
export { Outliner as component, OutlinerControls as headerControls } from '../../views/Outliner.tsx';
export const room = 'plan';
export const page = 'outliner';
export const title = 'Outliner';
export const help = 'outliner';
export const takesNode = true;
